export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_ITEM = "REMOVE_ITEM";
export const DECREASE = "DECREASE";
export const INCREASE = "DECREASE";
export const CHECKOUT = "CHECKOUT";
export const INCREMENT = "INCREMENT";
export const DECREMENT = "DECREMENT";
export const CLEAR = "CLEAR";
export const RESET = "RESET";
